import { Languages } from '@/lib/dictionaries';
import { createHmac } from 'crypto';

export async function requestResetPasswordEmail(
  lang: Languages,
  email: string,
): Promise<Response> {
  const SECRET_KEY = process.env.NEXT_PUBLIC_API_SECRET_KEY!;
  const hmac = createHmac('sha256', SECRET_KEY);
  const data = JSON.stringify({ email });
  hmac.update(data + '/api/users/verification/password');
  const expectedSignature = hmac.digest('hex');

  return fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/users/verification/password`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': lang,
        'x-api-key': process.env.NEXT_PUBLIC_API_KEY!,
        'x-signature': expectedSignature,
      },
      body: data,
    },
  );
}
